<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded && this.items.length > 0 ? 'Кратко' : 'Подробно'" :expandable="items.length > 0"><span v-html="headerHtml"></span></v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <template v-for="item in items">
        <v-layout row wrap>
          <v-flex xs8>{{item.tax}}</v-flex>
          <v-flex xs4><b><span v-html = "formatCurrency(item.amount)"></span></b></v-flex>
        </v-layout>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-tax-pay-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      isLoaded: false,
      revexps: []
    }),
    props: {
      model: {
        type: Object,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      if (this.model) {
        this.id = this.model.ogrn
      }
      this.fetchItems()
    },
    watch: {
      model: function (newVal, oldVal) {
        if (this.model) {
          this.id = this.model.ogrn
        }
        this.fetchItems()
      }
    },
    computed: {
      ...mapGetters({
      }),
      headerHtml () {
        var period = this.revexps && this.revexps.length > 0 ? this.revexps[0].period + ' г.' : ''
        var sumStr = null
        var sum = null
        if (this.items && this.items.length > 0) {
          sum = this.items.reduce((s, i) => s + i.amount, 0)
          sumStr = `Налоги и сборы <b>${this.formatCurrency(sum)}</b>`
        } else {
          sumStr = 'Налоги и сборы не опубликованы ФНС России'
        }
        var revenue = null
        var expenses = null
        var percent = ''
        var staff = ''
        if (this.revexps && this.revexps.length > 0) {
          revenue = `Доходы <b>${this.formatCurrency(this.revexps[0].revenue)}</b>`
          expenses = `Расходы <b>${this.formatCurrency(this.revexps[0].expense)}</b>`
          if (sum && this.revexps[0].revenue > 0) {
            percent = `(${((sum / this.revexps[0].revenue) * 100).toFixed(2)}%&nbspот&nbspдохода)`
          }
          if (this.model && this.model.staffNumber != null && this.model.staffNumber.value != null) {
            staff = `(при численности ${this.model.staffNumber.value} чел.)`
          }
        } else {
          revenue = 'Доходы не опубликованы ФНС России'
          expenses = 'Расходы не опубликованы ФНС России'
        }
        var taxOffence = ''
        if (this.model.taxOffence) {
          taxOffence = `Штраф за налоговые правонарушения <b>${this.formatCurrency(this.model.taxOffence)}</b>`
        }

        return `Доходы и расходы. Уплаченные налоги. <b>${period}</b><br/>${revenue} ${staff}<br/>${expenses} <br/> ${sumStr} ${percent} <br/>${taxOffence}`
      }
    },
    methods: {
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + '&nbspр.' : ''
      },
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о налогах из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/taxes',
          cb,
          cbError)
      },
      getRevExps (id, cb) {
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о доходах и расходах из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/revexps',
          cb,
          cbError)
      },
      fetchItems () {
        this.items = []
        if (this.id) {
          this.getItems(this.id, (data) => {
            this.items = data
            this.items.sort((a, b) => formats.compareString(a.tax, b.tax))
          })
          this.getRevExps(this.id, (data) => {
            this.revexps = data
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// TaxPayPanel.vue?781f1392